import { inr } from "../../../components/shared";

export const todayIso = () => new Date().toISOString().slice(0, 10);

export function FinanceCard({ title, children, testid }) {
  return (
    <div className="bg-card border rounded-xl p-5 space-y-3" data-testid={testid}>
      <h2 className="font-display font-bold">{title}</h2>
      {children}
    </div>
  );
}

export function NativeSelect({ className = "", children, ...props }) {
  return (
    <select
      className={`h-10 w-full rounded-md border border-input bg-background px-3 text-sm ${className}`}
      {...props}
    >
      {children}
    </select>
  );
}

export function DataTable({ columns, rows, rowKey, testid, empty = "No records yet." }) {
  return (
    <div className="bg-card border rounded-xl overflow-x-auto" data-testid={testid}>
      <table className="w-full text-sm">
        <thead className="bg-muted/60">
          <tr>
            {columns.map(([label, , align]) => (
              <th className={`p-3 ${align === "right" ? "text-right" : "text-left"}`} key={label}>
                {label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && (
            <tr>
              <td className="p-6 text-center text-muted-foreground" colSpan={columns.length}>
                {empty}
              </td>
            </tr>
          )}
          {rows.map((row) => (
            <tr className="border-t" data-testid={`${testid}-row-${rowKey(row)}`} key={rowKey(row)}>
              {columns.map(([label, render, align]) => (
                <td className={`p-3 ${align === "right" ? "text-right tabular-nums" : ""}`} key={label}>
                  {render(row)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export const money = (value) => inr(Number(value || 0));
